import { Component, HostListener, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../shared/config/app-config';
import { User, UserService } from '../../shared';
import { SucesstempComponent } from '../assessmentsucess/sucesstemp.component';

@Component({
  templateUrl: 'preventinginfection.component.html',
  styleUrls: ['./style.component.css'],
})

export class PreventinginfectionComponent implements OnInit {
  success: MatDialogRef<SucesstempComponent>;
  description: any = "";
  imageURL: string = environment.cloudeImageURL;
  activityBoardPDF: { url: string; withCredentials: boolean; };
  patdis: any;
  public data: Object;
  apiurl: any = environment.api_url;
  documenturl: string = environment.documenturl;
  timeset: any = environment.timelimit;
  //id: any;
  CurrentUser: User
  path: any;
  pathid: any;
  assigned: any;
  urlSafe: SafeResourceUrl;
  menustatus: boolean = false;
  enablebutton: boolean = false;
  twowaymsg: boolean = false;
  chckinsurvey: boolean = false;
  menu: any;
  pdfurl: any;
  public modalRef: BsModalRef;
  @ViewChild('content') content: TemplateRef<any>;
  resultedHref: any;
  constructor(

    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private dialog: MatDialog,
    public sanitizer: DomSanitizer,
    private userService: UserService,
    private modalService: BsModalService,
    private userservice: UserService

  ) {

  }


  pdfOption: any;

  ngOnInit() {

    //this.route.params.subscribe(params => this.id = params);
    // ////console.log(this.id)
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
      }
    );


    if (this.CurrentUser.item.hostModel == "CLOUD") {
      this.imageURL = environment.cloudeImageURL;
    } else {
      this.imageURL = environment.vmImageURL;
    }

    if (window.localStorage['pdfPath']) {
      this.pdfOption = JSON.parse(atob(window.localStorage['pdfPath']))
      if (this.pdfOption.type == 'html') {
        let pdfPath = {
          'url': encodeURI(this.documenturl + this.pdfOption.path)
        }
        this.userService
          .getpdf(pdfPath)
          .subscribe(
            data => {
              this.urlSafe = data;
              this.pdfurl = data;
              /* Commented to revert back the changes */
              //               var oldstr=data._body;
              //               oldstr = oldstr.substr(0, oldstr.length - 14);
              //               if(this.id.status == 'Falling Behind' || this.id.status == 'Up to speed')
              //               {
              //               oldstr += `<button class="btn but-mild-green" 
              //               style="text-transform: none;font-size: 20px;margin: 0 auto;color: rgb(255, 255, 255);
              //               text-transform: none;
              //               font-size: 20px;
              //               display: block;
              //               background: rgb(156, 39, 176) none repeat scroll 0% 0%;
              //               border-radius: 4px !important;
              //               border: 1px solid rgb(156, 39, 176);
              //               width: auto;
              //               padding: 5px 10px 5px 10px;">Complete
              //               It</button>`
              //               }
              //               oldstr += `</body></html>`
              // // var newstr=oldstr.toString().replace('</body></html>','<button class="btn but-mild-green" id="btnSubmit" style="text-transform: none;font-size: 20px;margin: 0 auto;">Complete It</button></body></html>');
              // // console.log(newstr)
              //               // console.log("data",data._body)
              //               this.urlSafe = oldstr
              //               this.pdfurl = oldstr
              //               console.log(oldstr);
              /* Commented to revert back the changes */
            })
      }
      else
        this.activityBoardPDF = {
          url: this.documenturl + this.pdfOption.path,
          withCredentials: true
        }
    }
    this.userService
      .getactivity(window.localStorage['Puser'])
      .subscribe(
        data => {
          for (var i = 0; i < data.length; i++) {
            for (var j = 0; j < data[i].data.length; j++) {
              if (data[i].data[j].materialHspPatientMappingId == this.pdfOption.id) {
                this.path = data[i].data[j].filePath;

                this.pathid = data[i].data[j].materialId;
                this.description = data[i].data[j].materialName
              }

            }
          }

        }

      );
    this.userService
      .fetchCkChForPatDisclaimer('Document', this.pdfOption.id)
      .subscribe(
        data => {

          this.patdis = data.patDisclaimer;

          // alert(this.patdis.patDisclaimer)
        }

      );

    this.userService.getassignedbydetails(this.pdfOption.materialId, 'Document')
      .subscribe(
        data => {

          this.assigned = data
          //////console.log(data)
          if (this.route.snapshot.url[0].path == 'preventinginfection') {

            this.CurrentUser.operationStatus = 'material'
            /* if(this.assigned.userRole== 'Care Coordinator' || this.assigned.userRole== 'Care Outcomes Manager') */
            if (this.assigned.userRole == 'Care Coordinator') {
              this.assigned.userRole = 'Care Navigator'
            }
            this.CurrentUser.operationMessage = this.userService.translateText('patient_portal.display_messages.requested_by.label')+'&nbsp;:&nbsp;' + this.assigned.name + ' &nbsp;<img alt="" class="rounded-circle pl" title="' + this.assigned.name + '" src="' + this.imageURL + this.assigned.userImagePath + '"> &nbsp;'
          }
        });


    this.getmenu();
  }

  getmenu() {
    this.userService.postuserinfoid('1', this.CurrentUser.item.userAccountId)
      .subscribe(
        data => {
          this.menu = data[1].menu;

          if (this.menu) {
            for (var i = 0; i < this.menu.length; i++) {
              if (this.menu[i].refName == 'PAT_TWOWAYMESSAGE') {
                this.menustatus = this.menu[i].status

              }
              else if (this.menu[i].refName == 'DIS_PAT_TWOWAYMESSAGE') {
                this.twowaymsg = this.menu[i].status
              }
              else if (this.menu[i].refName == 'DIS_PAT_CKCH_SURVEY') {
                this.chckinsurvey = this.menu[i].status
              }
            }
          }
        })


  }
  completesurvey() {
    this.enablebutton = true;
    let type = "Form"
    this.userService.updatesurvey(this.pdfOption.id, type)
      .subscribe(
        data => {

          //////console.log(data);
          if (data.updateStatus == "true") {
            this.userService.logAudit("updatereviewstatus", 0).subscribe(data => { })
            if (window.localStorage['Puser']) {
              this.userService.getusersession()
                .subscribe(
                  data => {
                    if (data)
                      this.userService.setUser(data[0].patientStageWorkflow[0]);
                  },
                  err => this.userService.purgeAuth()
                );
            }
            this.toastr.toastrConfig.timeOut = this.timeset;
            this.toastr.success(this.userService.translateText('patient_portal.display_messages.document_completed.success'));
            // this.success = this.dialog.open(SucesstempComponent,{disableClose:true});  
            //   this.success.componentInstance.assessment = 'activity';
            //   this.success.componentInstance.message = 'completed';
            this.router.navigateByUrl('/patient/dashboard');
          }
          else {

          }
        });
  }
  onNavigate() {
    let printContents, popupWin;
    if (this.pdfOption.type == 'html') {
      printContents = this.pdfurl.replace('<body>', '<body onload="window.print();window.close();" >')
      popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      popupWin.document.open();
      popupWin.document.write(`${printContents}`);
      popupWin.document.close();
    } else {
      printContents = this.activityBoardPDF.url
      window.open(printContents, '_blank', 'top=0,left=0,height=100%,width=auto');
    }
  }

  openpopup(href) {
    this.resultedHref = href;
    this.modalRef = this.modalService.show(this.content, {
      class: 'modal-dialog-centered modal-sm content_popup',
      ignoreBackdropClick: true
    });
  }

  @HostListener('document:click', ['$event'])
  pop_up_over(event) {
    //Commented as this point is not taken now
    // if (event.target.className == 'btn but-mild-green') {
    //   this.completesurvey();
    // }
    $(document).on('click', 'a', function (e) {
      e.preventDefault();
      self.localStorage.setItem('hyperLink', event.target.href);
      return false;
    });

    if (event.target.href) {
      if (localStorage.getItem('hyperLink') && !event.target.href.includes('#')) {
        this.openpopup(event.target.href);
      }
    }
  }

  onPressYes() {
    window.open(this.resultedHref, '_blank').focus();
    this.modalRef.hide();
    let viewedUaId, patSWFId;
    if (window.localStorage['superClientId']) {
      viewedUaId = window.localStorage.getItem('superClientId');
    }
    else if (window.localStorage['ccdetails']) {
      let ccdetails = JSON.parse(atob(window.localStorage['ccdetails']))
      viewedUaId = ccdetails.cnuseraccid
    }
    else {
      viewedUaId = this.CurrentUser.item.userAccountId;
    }
    if (window.localStorage['Puser']) {
      patSWFId = window.localStorage.getItem('Puser');
    }

    let obj = {
      "handShakeKey": "",
      "hspPatMaterialMapId": this.pdfOption.id,
      "latestViewedOn": "",
      "materialTypeId": 1, //For Form
      "patientSwfId": patSWFId,
      "viewedCount": 1,
      "viewedModeId": 1, //For Web
      "viewedUaId": viewedUaId
    };
    this.userService.trackExternalEmbeddedLink(obj)
      .subscribe(data => {

      });
  }

  onPressNo() {
    this.modalRef.hide();
  }

  timer = false
  @HostListener('window:scroll', ['$event'])
  getenabled(description) {
    if (description) {
      let desc = description.toString().toLowerCase()
      if (desc.search(this.userservice.translateText('patient_portal.assessment.care_partner.txt')) != -1) {
        return true
      } else {
        return false
      }
    }
  }

}